import React, { Component } from "react";
import ReactDOM from 'react-dom';
import ChordDiagram from 'react-chord-diagram';
import classes from "./Chord.module.css";

/* Other source for Kangero: Cranky 2 Normal 3 Sisterly 1 Snooty 2 */
/* The data is consistent. Look at the original code for this. */
/* [1,1,0,1,0, 5,2,2,1,1, 1,4,1,2,1, 1,1,1,1,2, 2,1,0,1,2, 0,3,2,1,2, 0,4,4,1,3,  0,0,0,0,0,0,0,0 ], */
const matrix = [ 
    [1,1,5,1,3, 2,1,0,2,1, 1,0,4,1,3, 1,3,1,2,1, 2,1,1,1,2, 1,0,1,2,1, 1,0,2,1,5,  0,0,0,0,0,0,0,0 ], 
    [2,1,1,4,1, 3,1,0,2,1, 1,2,2,1,5, 1,2,1,1,1, 0,1,3,1,3, 0,1,2,3,2, 1,1,1,3,0,  0,0,0,0,0,0,0,0 ],  
    [2,0,1,2,2, 5,2,0,4,2, 6,4,0,4,3, 1,1,1,0,3, 0,1,1,2,1, 1,1,4,2,4, 1,0,1,0,0,  0,0,0,0,0,0,0,0 ], 
    [1,1,1,1,0, 3,1,1,4,1, 3,2,1,3,2, 2,0,1,1,2, 3,3,0,1,2, 1,2,1,3,1, 2,3,5,0,1,  0,0,0,0,0,0,0,0 ],
    [0,2,2,2,0, 6,0,1,2,0, 2,4,0,0,1, 0,0,1,1,2, 0,0,0,1,4, 0,1,1,2,8, 0,1,3,2,1,  0,0,0,0,0,0,0,0 ], 
    [0,0,3,0,0, 1,1,0,1,2, 1,0,0,0,1, 1,1,0,0,1, 1,1,0,1,0, 0,1,1,1,1, 1,2,0,0,0,  0,0,0,0,0,0,0,0 ], 
    [0,1,2,2,0, 1,1,0,0,2, 1,1,1,0,2, 1,1,2,1,3, 0,1,2,0,1, 0,1,1,1,1, 0,2,1,0,1,  0,0,0,0,0,0,0,0 ], 
    [1,1,0,1,0, 5,2,2,1,1, 1,4,1,2,1, 1,1,1,1,2, 2,1,0,1,2, 0,3,2,1,2, 0,4,4,1,3,  0,0,0,0,0,0,0,0 ],

    [1,2,2,1,0,0,0,1,  0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0 ], 
    [1,1,0,1,2,0,1,1,  0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0 ], 
    [5,1,1,1,2,3,2,0,  0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0 ], 
    [1,4,2,1,2,0,2,1,  0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0 ],
    [3,1,2,0,0,0,0,0,  0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0 ],
    
    [2,3,5,3,6,1,1,5,  0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0 ],
    [1,1,2,1,0,1,1,2,  0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0 ],
    [0,0,0,1,1,0,0,2,  0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0 ],
    [2,2,4,4,2,1,0,1,  0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0 ],
    [1,1,2,1,0,2,2,1,  0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0 ],    
    
    [1,1,6,3,2,1,1,1,  0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0 ],    
    [0,2,4,2,4,0,1,4,  0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0 ],
    [4,2,0,1,0,0,1,1,  0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0 ],
    [1,1,4,3,0,0,0,2,  0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0 ],
    [3,5,3,2,1,1,2,1,  0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0 ],            
    
    [1,1,1,2,0,1,1,1,  0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0 ],
    [3,2,1,0,0,1,1,1,  0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0 ],
    [1,1,1,1,1,0,2,1,  0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0 ],       
    [2,1,0,1,1,0,1,1,  0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0 ],
    [1,1,3,2,2,1,3,2,  0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0 ],
    
    [2,0,0,3,0,1,0,2,  0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0 ],
    [1,1,1,3,0,1,1,1,  0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0 ],
    [1,3,1,0,0,0,2,0,  0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0 ],
    [1,1,2,1,1,1,0,1,  0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0 ],
    [2,3,1,2,4,0,1,2,  0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0 ],
    
    [1,0,1,1,0,0,0,0,  0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0 ],
    [0,1,1,2,1,1,1,3,  0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0 ],
    [1,2,4,1,1,1,1,2,  0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0 ],   
    [2,3,2,3,2,1,1,1,  0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0 ],
    [1,2,4,1,8,1,1,2,  0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0 ],
    
    [1,1,1,2,0,1,0,0,  0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0 ],
    [0,1,0,3,1,2,2,4,  0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0 ],
    [2,1,1,5,3,0,1,4,  0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0 ],
    [1,3,0,0,2,0,0,1,  0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0 ],
    [5,0,0,1,1,0,1,3,  0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0 ]
]; 

/* // Data below is not updated 
const matrix = [ 
    [1,1,5,1,3,2,1,0,2,1, 1,0,4,1,3,1,3,1,2,1, 2,1,1,1,2,1,0,1,2,1, 1,0,2,1,5,  0,0,0,0,0,0,0,0 ], 
    [2,1,1,4,1,3,1,0,2,1, 1,2,2,1,5,1,2,1,1,1, 0,1,3,1,3,0,1,2,3,2, 1,1,1,3,0,  0,0,0,0,0,0,0,0 ],  
    [2,0,1,2,2,3,2,0,4,2, 6,4,0,4,3,1,1,1,0,3, 0,1,1,2,1,1,1,4,2,4, 1,0,1,0,0,  0,0,0,0,0,0,0,0 ], 
    [1,1,1,1,0,3,1,1,4,1, 3,2,1,3,2,2,0,1,1,2, 3,3,0,1,2,1,2,1,3,1, 2,3,5,0,1,  0,0,0,0,0,0,0,0 ],
    [0,2,2,2,0,5,0,1,2,0, 2,4,0,0,1,0,0,1,1,2, 0,0,0,1,4,0,1,1,2,8, 0,1,3,2,1,  0,0,0,0,0,0,0,0 ], 
    [0,0,3,0,0,1,1,0,1,2, 1,0,0,0,1,1,1,0,0,1, 1,1,0,1,0,0,1,1,1,1, 1,2,0,0,0,  0,0,0,0,0,0,0,0 ], 
    [0,1,2,2,0,1,1,0,0,2, 1,1,1,0,2,1,1,2,1,3, 0,1,2,0,1,0,1,1,1,1, 0,2,1,0,1,  0,0,0,0,0,0,0,0 ], 
    [1,1,0,1,0,5,2,2,1,1, 1,4,1,2,1,1,1,1,1,2, 2,1,0,1,2,0,3,2,1,2, 0,4,4,1,3,  0,0,0,0,0,0,0,0 ],

    [1,2,2,1,0,0,0,1,  0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0 ], 
    [1,1,0,1,2,0,1,1,  0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0 ], 
    [5,2,2,1,3,3,2,0,  0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0 ], 
    [1,4,2,1,2,0,2,1,  0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0 ],
    [3,1,2,0,0,0,0,0,  0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0 ],
[20,4,5,23,5,1,12,15,  0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0 ],
    [1,1,2,1,0,1,1,3,  0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0 ],
    [0,0,0,1,1,0,0,2,  0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0 ],
    [2,2,5,4,3,1,1,1,  0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0 ],
    [1,1,2,1,0,2,2,1,  0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0 ],    
    [1,2,6,3,2,1,1,1,  0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0 ],    
    [0,2,4,2,4,0,1,4,  0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0 ],
    [4,2,0,1,0,0,1,1,  0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0 ],
    [1,1,4,3,0,0,0,2,  0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0 ],
    [3,5,3,2,1,1,2,1,  0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0 ],            
    [1,1,1,2,0,1,1,1,  0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0 ],
    [3,2,1,0,0,1,1,1,  0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0 ],
    [1,1,1,1,1,0,2,1,  0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0 ],       
    [2,1,0,1,1,0,1,1,  0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0 ],
    [1,1,3,2,1,2,3,2,  0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0 ],
    [2,0,0,3,0,1,0,2,  0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0 ],
    [1,1,1,3,0,1,1,1,  0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0 ],
    [1,3,1,0,0,0,2,0,  0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0 ],
    [1,1,2,1,1,1,0,1,  0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0 ],
    [2,3,1,2,4,0,1,2,  0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0 ],
    [1,0,1,1,0,0,0,0,  0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0 ],
    [1,3,1,2,2,1,2,3,  0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0 ],
    [1,2,4,1,2,1,1,2,  0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0 ],   
    [2,3,2,3,2,1,1,1,  0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0 ],
    [1,2,4,1,8,1,1,2,  0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0 ],
    [1,1,1,2,0,1,0,0,  0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0 ],
    [0,1,0,3,1,2,2,1,  0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0 ],
    [2,1,1,5,3,1,1,4,  0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0 ],
    [1,3,0,0,2,0,0,1,  0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0 ],
    [5,0,0,1,1,0,1,2,  0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0 ]
]; */
function getRandomColor() {
    var letters = '0123456789ABCDEF'.split('');
    var color = '#'; // '#'
    for (var i = 0; i < 6; i++ ) {
        color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
}
var myColors_array = [];
var c;
for(c=0; c<44; c++) {
    var myColorResult = getRandomColor();
    myColors_array[c] = myColorResult;
    
}
console.log(myColors_array);
  
export default class Chord extends Component {
    render() {
        return (
            <div id="chordId">
                <div className={classes.graphContainer}>
                    <ChordDiagram
                        matrix={matrix}
                        componentId={1}
                        width={600}
                        height={600}
                        margin={10}
                        groupLabels={['Cranky', 'Jock', 'Lazy', 'Normal', 'Peppy', 'Sisterly', 'Smug', 'Snooty', 
                            'Alligator', 'Anteater',
                            'Bear', 'Bird', 'Bull',
                            'Cat', 'Chick', 'Cow', 'Cub',
                            'Deer', 'Dog', 'Duck',
                            'Eagle', 'Elephant',
                            'Frog',
                            'Goat', 'Gorilla',
                            'Hamster', 'Hippo', 'Horse',
                            "K'roo", 'Koala',
                            'Lion',
                            'Monkey', 'Mouse',
                            'Octopus', 'Ostrich',
                            'Penguin', 'Pig',
                            'Rabbit', 'Rhino',
                            'Sheep', 'Squirrel',
                            'Tiger',
                            'Wolf'
                        ]}
                        groupColors={myColors_array}
                    />
                </div>
            </div>
        )
    }   
}    